import { t } from "@lingui/core/macro";
import type { GeoJsonProperties } from "geojson";
import React from "react";
import { renderToStaticMarkup } from "react-dom/server";

// TODO EON only for now
type GeojsonTooltipProps = {
  data: Record<string, any>[];
};

export function EonGeojsonTooltip({ data }: GeojsonTooltipProps) {
  const first = data[0] || {};
  const isActive =
    first.threshold_value !== undefined && first.value !== undefined && first.value > first.threshold_value;

  return (
    <div className="mapbox-tooltip">
      <div className={`status-header ${isActive ? "active" : "inactive"}`}>
        {isActive ? t`Threshold reached`.toUpperCase() : t`Threshold not reached`.toUpperCase()}
      </div>
      <div className="table">
        <div className="header">
          <div className="column">{t`Name`}</div>
          <div className="column">{t`Threshold value`}</div>
          <div className="column">{t`Coordinates`}</div>
        </div>
        <div className="body">
          {data.map((item, i) => {
            const lat = item.lat;
            const lon = item.lon;
            const coord = lat !== undefined && lon !== undefined ? `${lon.toFixed(4)}, ${lat.toFixed(4)}` : "-";
            return (
              // biome-ignore lint/suspicious/noArrayIndexKey: does not matter
              <div className="row" key={i}>
                <div className="column">{item.name ?? "-"}</div>
                <div className="column">{item.threshold_value ?? "-"}</div>
                <div className="column">{coord}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
// cadent gas tooltip
export function CGGeojsonTooltip({ data }: GeojsonTooltipProps) {
  // compute lowest severity level across items (lower = higher warning)
  const severities = Array.isArray(data)
    ? data
        .map((item) => (item?.severity_level !== undefined ? Number(item.severity_level) : undefined))
        .filter((v): v is number => Number.isFinite(v))
    : [];
  const severity = severities.length ? Math.min(...severities) : 5;
  // map header color class based on severity
  const headerClass = severity === 1 ? "level-1" : severity === 2 ? "level-2" : severity === 3 ? "level-3" : "inactive";

  const headerLabel =
    // severity === 1 || severity === 2 || severity === 3 ? `${t`Warning`}`.toUpperCase() : t`No warning`.toUpperCase();
    data[0]?.severity ? data[0].severity.toUpperCase() : t`No warning`.toUpperCase();

  return (
    <div className="mapbox-tooltip">
      <div className={`status-header ${headerClass}`}>{headerLabel}</div>
      <div className="table" style={{ ["--cols" as any]: 5 }}>
        <div className="header">
          <div className="column">{"Name"}</div>
          <div className="column">{"TA Code"}</div>
          <div className="column">{"Asset ref"}</div>
          <div className="column">{"Reason"}</div>
          <div className="column">{"Severity"}</div>
        </div>
        <div className="body">
          {data.map((item, i) => {
            return (
              // biome-ignore lint/suspicious/noArrayIndexKey: does not matter
              <div className="row" key={i}>
                <div className="column">{item.asset_name ?? "-"}</div>
                <div className="column">{item.ta_code ?? "-"}</div>
                <div className="column">{item.asset_ref ?? "-"}</div>
                <div className="column">{item.monitor_reason ?? "-"}</div>
                <div className="column">{item.severity_level ?? "-"}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export function createGeojsonPOIPopover(features: GeoJsonProperties[]) {
  const data = features.map((feature) => feature?.properties || {});
  return renderToStaticMarkup(data[0]?.ta_code ? <CGGeojsonTooltip data={data} /> : <EonGeojsonTooltip data={data} />);
}
